import React, { useEffect } from 'react';
import { CalendarDays, MapPin, ShieldCheck } from 'lucide-react';
import SessionCountdown from '../components/home/SessionCountdown';
import { siteInfo } from '../data/mock';
import { trackEnrollment } from '../lib/pixel';

const TYPEFORM_ID = '01M4GKC0SNE95NJCKHTHR82RDX';
const TYPEFORM_SCRIPT_SRC = 'https://embed.typeform.com/next/embed.js';

export default function Enroll() {
  useEffect(() => {
    window.lsTypeformSubmitted = () => trackEnrollment({ source: 'typeform' });
    const existing = document.querySelector(`script[src="${TYPEFORM_SCRIPT_SRC}"]`);
    if (existing) {
      // Script already loaded — ask Typeform to rescan the DOM for new embeds
      if (window.tf && typeof window.tf.load === 'function') {
        try { window.tf.load(); } catch (_) { /* noop */ }
      }
      return;
    }
    const s = document.createElement('script');
    s.src = TYPEFORM_SCRIPT_SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <main>
      <SessionCountdown variant="compact" />

      <section className="py-14 md:py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Winter 2026&ndash;27 Enrollment</div>
          <h1 className="font-display font-bold text-4xl md:text-6xl text-splash-green leading-tight">
            Reserve your <span className="text-splash-teal">swimmer&rsquo;s</span> spot.
          </h1>
          <p className="mt-5 text-splash-green/80 max-w-2xl mx-auto leading-relaxed">
            Fill out the quick form below and Coach Abrie will confirm your spot by email within 24 hours.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto text-left">
            <div className="bg-white rounded-2xl p-5 border border-splash-sand flex items-start gap-3">
              <CalendarDays className="w-5 h-5 text-splash-teal mt-0.5" />
              <div>
                <div className="font-semibold text-splash-green text-sm">Monthly membership</div>
                <div className="text-xs text-splash-green/70">Enrollment opens Oct 30, 2026</div>
              </div>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-splash-sand flex items-start gap-3">
              <MapPin className="w-5 h-5 text-splash-teal mt-0.5" />
              <div>
                <div className="font-semibold text-splash-green text-sm">Des Moines, IA</div>
                <div className="text-xs text-splash-green/70">{siteInfo.address}</div>
              </div>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-splash-sand flex items-start gap-3">
              <ShieldCheck className="w-5 h-5 text-splash-teal mt-0.5" />
              <div>
                <div className="font-semibold text-splash-green text-sm">ISSA Accredited</div>
                <div className="text-xs text-splash-green/70">WSI-certified instructors</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-3xl border border-splash-sand shadow-sm p-4 md:p-6">
            <div
              data-tf-live={TYPEFORM_ID}
              data-tf-on-submit="lsTypeformSubmitted"
              data-testid="enroll-typeform"
              style={{ minHeight: '620px' }}
            />
          </div>
          <p className="text-center text-xs text-splash-green/60 mt-4">
            Having trouble with the form? Email us at{' '}
            <a href={`mailto:${siteInfo.email}`} className="underline">{siteInfo.email}</a>.
          </p>
        </div>
      </section>
    </main>
  );
}
